'use strict';

import _ from 'underscore';

export default function CustomSitesController(
  $http,
  FlashService,
  SiteService
) {
  var vm = this;
  vm.destroy = destroy;
  vm.save = save;
  vm.DEVICES = ['mobile', 'desktop'];

  return vm;

  function destroy(site) {
    vm.partner.sites = _.without(vm.partner.sites, site);
  }

  function create(site) {
    return SiteService.create(site)
      .then(function(response) {
        site.id = response.data.id;
        site.errors = [];
        FlashService.push('success', 'Your site has been saved.');
      })
      .catch(function(response) {
        site.errors = response.data.errors;
      });
  }

  function update(site) {
    return SiteService.update(site)
      .then(function() {
        site.errors = [];
        FlashService.push('success', 'Your site has been saved.');
      })
      .catch(function(response) {
        site.errors = response.data.errors;
      });
  }

  function save(site) {
    if (site.id) {
      return update(site);
    }

    return create(site);
  }
}

CustomSitesController.$inject = ['$http', 'FlashService', 'SiteService'];
